import Layout from '../views/layout'
import { PermissionKey } from '@pt/enums/user'
import i18n from '@/lang'
// import { isCNSuffix } from '@com/utils/url'
// import { hasPermission } from '@pt/plugins/permission-manager/manager'

export default {
  path: '/creative-template',
  component: Layout,
  redirect: 'noredirect',
  name: 'creative-template',
  icon: 'stencil',
  meta: {
    title: i18n.t('playTurbo.leftMenu.aside.menu.creative.name'),
    keys: ['gm'],
  },
  children: [
    {
      path: 'playable',
      name: 'creative-template.playable',
      redirect: 'playable/lib',
      component: () => import('@pt/views/creative-template/playable/index.vue'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.creative.playable'),
        defaultPath: '/creative-template/playable',
        keys: ['gm'],
      },
      children: [
        {
          path: 'lib',
          name: 'creative-template.lib',
          component: () =>
            import('@pt/views/creative-template/playable/lib.vue'),
          meta: {
            title: i18n.t('playTurbo.home.playable.public'),
            tab: 'lib',
            defaultPath: '/creative-template/playable',
            keys: ['gm'],
          },
        },
        {
          path: 'stars',
          name: 'creative-template.stars',
          component: () =>
            import('@pt/views/creative-template/playable/stars.vue'),
          meta: {
            title: i18n.t('playTurbo.home.playable.collection'),
            tab: 'stars',
            defaultPath: '/creative-template/playable',
            keys: ['gm'],
          },
        },
      ],
    },
    {
      path: 'video',
      name: 'creative-template.video',
      redirect: 'video/lib',
      component: () => import('@pt/views/creative-template/video/index.vue'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.creative.video'),
        defaultPath: '/creative-template/video',
      },
      children: [
        {
          path: 'lib',
          name: 'creative-template.video.lib',
          component: () => import('@pt/views/creative-template/video/lib.vue'),
          meta: {
            title: i18n.t('playTurbo.home.playable.public'),
            tab: 'lib',
            defaultPath: '/creative-template/video',
            keys: [PermissionKey.VeTpl, PermissionKey.International],
          },
        },
      ],
    },
    {
      path: 'multi-template',
      name: 'creative-template.multi-template',
      component: () =>
        import('@pt/views/creative-template/multi-template/index.vue'),
      meta: {
        title: i18n.t(
          'playTurbo.templateLibrary.template.filter.commonTemplate',
        ),
        defaultPath: '/creative-template/multi-template',
        keys: [PermissionKey.VeTpl, PermissionKey.International],
      },
    },
  ],
}
